export default __webpack_public_path__ + "static/media/aion-promo-logo.5c5a2eb8.png";